import { z } from 'zod';

const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

const dealRouteParamsSchema = z.object({
  dealId: z.string().regex(UUID_REGEX),
});

export interface DealRouteParamsInput {
  dealId?: string;
}

export type DealRouteParams = z.infer<typeof dealRouteParamsSchema>;

export function normalizeDealRouteParams(params: DealRouteParamsInput): DealRouteParams | null {
  const parsed = dealRouteParamsSchema.safeParse(params);
  if (!parsed.success) return null;
  return parsed.data;
}
